import { render, staticRenderFns } from "./SelectionLabel.vue?vue&type=template&id=5e06cfdf&scoped=true&"
import script from "./SelectionLabel.vue?vue&type=script&lang=js&"
export * from "./SelectionLabel.vue?vue&type=script&lang=js&"
import style0 from "./SelectionLabel.vue?vue&type=style&index=0&id=5e06cfdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e06cfdf",
  null
  
)

export default component.exports